export enum SpecialCampaignApprovalEnum {
  Pending = 1,
  Approved = 2,
  Disapproved = 3,
  ContractSigned = 4,
}

export const specialCampaignApprovalList = [
  {
    label: "pages.LabelManagement.pending",
    value: SpecialCampaignApprovalEnum.Pending,
  },
  {
    label: "pages.LabelManagement.approved",
    value: SpecialCampaignApprovalEnum.Approved,
  },
  {
    label: "pages.LabelManagement.disapproved",
    value: SpecialCampaignApprovalEnum.Disapproved,
  },
  {
    label: "pages.LabelManagement.contractSigned",
    value: SpecialCampaignApprovalEnum.ContractSigned,
  },
];
